import React from 'react';

export const LoggedUserContext = React.createContext({
    userId: String,
    userEmail: String,
    userFirstName: String,
    userLastName: String,
    userStatus: Boolean,
    userCreateDate: String,
    userLastUpdateDate: String,
    userModifiedId: String,
  });